<template>
  <ion-page>
    <ion-content color="primary" class="recovery-wrapper">
      <ion-row class="ion-padding">
        <ion-col size-md="12" size-lg="12">
          <section class="recovery-wrapper__body">
            <div class="recovery-wrapper__logo ion-justify-content-center">
              <ion-img v-if="arriboLogo" :src="arriboLogo" alt="Arribo Logo"></ion-img>
            </div>
          </section>
        </ion-col>
      </ion-row>
    </ion-content>
    <ion-footer>
      <ion-row class="ion-padding">
        <ion-col size-md="12" size-lg="12">
          <section class="recovery-wrapper__form ion-padding">
            <h3 class="h3 text-color-body text-align-center">{{ t('recovery.title') }}</h3>
            <p class="text-color-body text-align-left font-xs">
              {{ t('signUp.passwordDescription') }}
            </p>
            <ul class="font-xs">
              <li>{{ t('signUp.passwordDescriptionLeast.minCharacters') }}</li>
              <li>{{ t('signUp.passwordDescriptionLeast.uppercase') }}</li>
              <li>{{ t('signUp.passwordDescriptionLeast.lowercase') }}</li>
              <li>{{ t('signUp.passwordDescriptionLeast.number') }}</li>
              <li>{{ t('signUp.passwordDescriptionLeast.special') }}</li>
            </ul>
            <div class="mt-lg">
              <Form
                form-name="recovery"
                id="recoveryForm"
                :validation-schema="schemaResetPassword"
                @submit="handleResetPasswordSubmit"
              >
                <ion-row gap="0">
                  <ion-col size="12">
                    <CustomInput
                      form-name="login"
                      type="password"
                      :value="password"
                      v-model="password"
                      input-type="password"
                      :label="t('login.labels.password')"
                      name="password"
                      class-name="custom-field"
                      :placeholder="t('login.placeholders.password')"
                      :icon="lockClosedOutline"
                      :clear-field="false"
                    />
                  </ion-col>
                </ion-row>
                <ion-row class="mt-8">
                  <ion-col size="12">
                    <ion-button
                      :disabled="loading"
                      fill="solid"
                      class="text-sm"
                      color="primary"
                      expand="block"
                      size="default"
                      type="submit"
                    >
                      {{ t('actions.recovery') }}
                    </ion-button>
                  </ion-col>
                  <ion-col size="12">
                    <ion-button
                      fill="clear"
                      class="text-lg text-underline mt-lg mb-lg"
                      color="primary"
                      expand="block"
                      size="small"
                      @click="goTo('login')"
                    >
                      {{ t('welcome.haveAnAccount') }}
                    </ion-button>
                  </ion-col>
                </ion-row>
              </Form>
            </div>
          </section>
        </ion-col>
        <ion-progress-bar v-if="loading" type="indeterminate"></ion-progress-bar>
      </ion-row>
    </ion-footer>
  </ion-page>
</template>
<script setup lang="ts">
  import {
    IonPage,
    IonContent,
    IonRow,
    IonCol,
    IonImg,
    IonButton,
    IonFooter,
    IonProgressBar,
  } from '@ionic/vue';
  import arriboLogo from '@/assets/images/arribo-logo.svg';
  import { useAuth } from '@/composables/useAuth';
  import { useI18n } from 'vue-i18n';
  import { onMounted, ref } from 'vue';
  import { Form } from 'vee-validate';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { lockClosedOutline } from 'ionicons/icons';
  import { useProfile } from '@/composables/useProfile';
  import { useRoute } from 'vue-router';
  import { useSchemas } from '@/composables/useSchemas';

  const { schemaResetPassword } = useSchemas();
  const { goTo } = useAuth();
  const { handleResetPassword, recoveryPasswordSuccess, loading } = useProfile();
  const { t } = useI18n();
  const route = useRoute();

  const showErr = ref(false);
  const password = ref('');
  const token = ref('');

  const handleResetPasswordSubmit = () => {
    goResetPassword();
  };

  const goResetPassword = () => {
    loading.value = true;
    showErr.value = false;
    try {
      handleResetPassword(password.value, token.value).then(() => {
        loading.value = false;
        if (recoveryPasswordSuccess.value) {
          goTo('login');
        }
      });
    } catch (error: unknown) {
      loading.value = false;
      const errorMsg = error?.toString() ?? 'Unknown error!';
      if (errorMsg === 'Error: Invalid email!') {
        showErr.value = true;
      }
    }
  };

  const initialConfig = async () => {
    if (route.query.token) {
      token.value = route.query.token as string;
    }
  };

  onMounted(() => {
    initialConfig();
  });
</script>
<style scoped lang="scss">
  .recovery-wrapper {
    position: relative;

    &__logo {
      position: relative;
      margin-top: 70px;
      width: 100%;
      display: flex;
      justify-content: center;

      ion-img {
        width: 190px;
      }
    }

    &__form {
      width: 100%;
      border-radius: 16px;
      background: #ffffff;
      min-height: 200px;
      margin-bottom: 50px;
    }
  }

  @media screen and (min-width: 576px) {
  }

  @media screen and (min-width: 768px) {
  }

  @media screen and (min-width: 992px) {
  }

  @media screen and (min-width: 1200px) {
  }

  @media screen and (min-width: 1490px) {
  }
</style>
